import { render, staticRenderFns } from "./GroupsByVerifactu.vue?vue&type=template&id=9d66bd54&scoped=true"
import script from "./GroupsByVerifactu.vue?vue&type=script&lang=js"
export * from "./GroupsByVerifactu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d66bd54",
  null
  
)

export default component.exports